import { PLAYER_HEADSHOT_FALLBACK } from "../../../config/constants";

export function InsightCard(props) {
    const { label, player, value, unit, headshotUrl } = props;
    if (!player) return null;

    return (
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex items-center gap-4">
        <img
          src={headshotUrl || PLAYER_HEADSHOT_FALLBACK}
          alt={player.player_name}
          className="w-14 h-14 rounded-full object-cover bg-gray-100 flex-shrink-0 ring-2 ring-gray-100"
          onError={(e) => { e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK; }}
        />
        <div className="min-w-5">
          <div className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest mb-0.5">{label}</div>
          <div className="text-2xl font-bold text-gray-900 leading-none">{value}</div>
          <div className="text-[11px] text-gray-400 mt-0.5">{unit}</div>
          <div className="text-sm font-semibold text-gray-700 truncate mt-1">{player.player_name}</div>
        </div>
      </div>
    );
  }